/**
 * A simple geometry type 
 */
enum GeometryTypeEnum {

    /**
     * Unknown / Not Specified
     */
    Unknown = 0,

    
    /**
     * Point Geometry
     */
    Point = 1,

    /**
     * Line Geometry
     */
    Line = 3,
    
    /**
     * Polygon Geometry
     */
    Polygon = 4,
 
    
    
}

export default GeometryTypeEnum;